import "../chunk-UKSPFOP7.js";
import { useOrganization } from "@clerk/shared";
export {
  useOrganization
};
//# sourceMappingURL=useOrganization.js.map